import React, { Component } from 'react';
import { TagColor } from '../../../../types';
import './aiTag.scss';

interface IAiTagProps {
    tag: string;
    color: TagColor;
}

export default class AiTag extends Component<IAiTagProps, {}> {
    public render() {
        return (
            <div key={Math.random()} className={`ai-tag tag-${this.props.color}`}>
                {this.props.tag}
            </div>
        );
    }
}
